export function header() {

    if (window.innerWidth > 1200) {
        $(".main-menu .menu-item-has-children").hover(function () {
            $(this).addClass('opened');
            $(this).find('.sub-menu').css("opacity", "1");
        }, function () {
            $(this).removeClass('opened');
            $(this).find('.sub-menu').css("opacity", "0");
        });
    }

    const siteHeader = $(".header");


    // Document Top Offset
    $(".main").css("padding-top", siteHeader.outerHeight() + "px");

    // Init Counterup
    $('.counter').counterUp({
        delay: 10,
        time: 1000
    });

    // Init animations
    AOS.init();

    // Scroll Header

    var header = document.querySelector(".header");
    var lastScrollTop = 0;

    window.onscroll = function() {
        scrollHide();
        $('.main-menu .sub-menu.mega-menu').css("opacity", "0");
        $('.main-menu .menu-item-has-children').removeClass('opened');
    };

    function scrollHide() {
        var st = window.pageYOffset || document.documentElement.scrollTop;
        if (st > lastScrollTop) {
            header.classList.add('hide');
        } else {
            header.classList.remove('hide');
        }
        lastScrollTop = st <= 0 ? 0 : st;
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/header.js